import type {
  AdminPermissions,
  AmlPermissions,
  ClientPermissions,
  FilePermissions,
  InvoicePermissions,
  OnboardingPermissions,
  SkynetUserEffectivePermissions,
} from "./RolesAndPermissionsModels";

export const ADMIN_PERMISSION_LABELS: Record<AdminPermissions, string> = {
  USER: "permissions.admin.user",
  RULE: "permissions.admin.rule",
  LEGAL: "permissions.admin.legal",
  CONFIGURATION: "permissions.admin.configuration",
  USER_GROUP: "permissions.admin.userGroup",
};

export const AML_PERMISSION_LABELS: Record<AmlPermissions, string> = {
  AML_RISK_SCORE: "permissions.aml.amlRiskScore",
  AML_MONITORING: "permissions.aml.amlMonitoring",
  AML_LOG: "permissions.aml.amlLog",
  AML_EXPORT: "permissions.aml.amlExport",
  BLACKLIST: "permissions.aml.blacklist",
  DEBT_COLLECTION: "permissions.aml.debtCollection",
};

export const CLIENT_PERMISSION_LABELS: Record<ClientPermissions, string> = {
  EMAIL_ADDRESS_CONNECTION: "permissions.client.emailAddressConnection",
  ACCOUNT_PLAN: "permissions.client.accountPlan",
  USER: "permissions.client.user",
  SETTINGS: "permissions.client.settings",
  SETTLEMENT: "permissions.client.settlement",
  PAYMENT: "permissions.client.payment",
  LIMITS: "permissions.client.limits",
};

export const FILE_PERMISSION_LABELS: Record<FilePermissions, string> = {
  SETTLEMENT: "permissions.file.settlement",
  INVOICE_DOCUMENT_INGRESS: "permissions.file.invoiceDocumentIngress",
};

export const INVOICE_PERMISSION_LABELS: Record<InvoicePermissions, string> = {
  INVOICE_UPLOAD_UNIT: "permissions.invoice.invoiceUploadUnit",
  INVOICE_INTERPRETATION: "permissions.invoice.invoiceInterpretation",
  INVOICE: "permissions.invoice.invoice",
  FORCE_ASSESSMENT_APPROVAL: "permissions.invoice.forceAssessmentApproval",
  EXEMPTION_VERIFIERA: "permissions.invoice.exemptionVerifiera",
  EXEMPTION_RECIPIENT_APPROVAL_RULES:
    "permissions.invoice.exemptionRecipientApprovalRules",
  EXEMPTION_OTHER_RULES: "permissions.invoice.exemptionOtherRules",
  EXEMPTION_LIMITS_RULES: "permissions.invoice.exemptionLimitsRules",
  EXEMPTION_INTERNAL_INVOICING:
    "permissions.invoice.exemptionInternalInvoicing",
  EXEMPTION_BLACKLIST_RULES: "permissions.invoice.exemptionBlacklistRules",
};

export const ONBOARDING_PERMISSION_LABELS: Record<
  OnboardingPermissions,
  string
> = {
  BANK: "permissions.onboarding.bank",
  AGREEMENT: "permissions.onboarding.agreement",
  KYC: "permissions.onboarding.kyc",
  INTERNAL_KYC: "permissions.onboarding.internalKyc",
  SALES: "permissions.onboarding.sales",
  INTERNAL_SALES: "permissions.onboarding.internalSales",
  CREDIT_APPROVAL: "permissions.onboarding.creditApproval",
  FINALIZE: "permissions.onboarding.finalize",
  PROSPECT: "permissions.onboarding.prospect",
};

export type PermissionOverridePreview = Partial<
  Record<
    keyof SkynetUserEffectivePermissions,
    { read?: string[]; write?: string[] }
  >
>;

export const PERMISSION_CATEGORIES: Array<{
  key: keyof SkynetUserEffectivePermissions;
  titleKey: string;
  labels: Record<string, string>;
}> = [
  {
    key: "admin",
    titleKey: "permissions.categories.admin",
    labels: ADMIN_PERMISSION_LABELS,
  },
  {
    key: "aml",
    titleKey: "permissions.categories.aml",
    labels: AML_PERMISSION_LABELS,
  },
  {
    key: "client",
    titleKey: "permissions.categories.client",
    labels: CLIENT_PERMISSION_LABELS,
  },
  {
    key: "file",
    titleKey: "permissions.categories.file",
    labels: FILE_PERMISSION_LABELS,
  },
  {
    key: "invoice",
    titleKey: "permissions.categories.invoice",
    labels: INVOICE_PERMISSION_LABELS,
  },
  {
    key: "onboarding",
    titleKey: "permissions.categories.onboarding",
    labels: ONBOARDING_PERMISSION_LABELS,
  },
];
